import {
  DeleteOutlined,
  EditOutlined,
  PushpinOutlined,
} from "@ant-design/icons";
import { Badge, Button, Popconfirm, Space, Table, Tag, Tooltip } from "antd";

export function AnnouncementList({
  data = [],
  loading,
  total,
  filter,
  onFilterChange,
  onEdit,
  onDelete,
  onTogglePin,
}) {
  const priorityColors = {
    low: "default",
    normal: "blue",
    high: "orange",
    urgent: "red",
  };

  const priorityLabels = {
    low: "Thấp",
    normal: "Bình thường",
    high: "Cao",
    urgent: "Khẩn cấp",
  };

  const columns = [
    {
      title: <strong>STT</strong>,
      dataIndex: "key",
      key: "key",
      width: 60,
      align: "center",
      render: (text) => <strong>{text}</strong>,
    },
    {
      title: <strong>Hình ảnh</strong>,
      dataIndex: "imageUrl",
      key: "imageUrl",
      width: 150,
      align: "center",
      render: (imageUrl, record) =>
        imageUrl ? (
          <img
            src={imageUrl}
            alt={record.title}
            style={{
              width: 120,
              height: 68,
              objectFit: "cover",
              borderRadius: 6,
              boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
            }}
          />
        ) : (
          <div
            style={{
              width: 120,
              height: 68,
              backgroundColor: "#f0f0f0",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "#999",
              borderRadius: 6,
              fontSize: 12,
            }}
          >
            Không có hình
          </div>
        ),
    },
    {
      title: <strong>Tiêu đề</strong>,
      dataIndex: "title",
      key: "title",
      width: 250,
      render: (title, record) => (
        <Tooltip title={title}>
          <div>
            <strong>{title}</strong>
            {record.isPinned && (
              <Tag color="gold" size="small" style={{ marginLeft: 8 }}>
                Đã ghim
              </Tag>
            )}
          </div>
        </Tooltip>
      ),
    },
    {
      title: <strong>Mức độ ưu tiên</strong>,
      dataIndex: "priority",
      key: "priority",
      align: "center",
      width: 120,
      render: (priority) => (
        <Tag color={priorityColors[priority] || "default"}>
          {priorityLabels[priority] || priority}
        </Tag>
      ),
    },
    {
      title: <strong>Người tạo</strong>,
      dataIndex: ["createdBy", "name"],
      key: "createdBy",
      width: 150,
    },
    {
      title: <strong>Trạng thái</strong>,
      dataIndex: "isActive",
      key: "isActive",
      align: "center",
      width: 120,
      render: (isActive) => (
        <Badge
          status={isActive ? "success" : "error"}
          text={isActive ? "Hoạt động" : "Ngừng hoạt động"}
        />
      ),
    },
    {
      title: <strong>Hành động</strong>,
      key: "action",
      width: 150,
      fixed: "right",
      align: "center",
      render: (_, record) => (
        <Space size="small">
          <Tooltip title="Ghim/Bỏ ghim">
            <Button
              type="text"
              size="small"
              icon={<PushpinOutlined />}
              onClick={() => onTogglePin(record)}
              style={{ color: record.isPinned ? "#faad14" : undefined }}
            />
          </Tooltip>
          <Tooltip title="Sửa">
            <Button
              type="text"
              size="small"
              icon={<EditOutlined />}
              onClick={() => onEdit(record)}
              style={{ color: "#1890ff" }}
            />
          </Tooltip>
          <Popconfirm
            title="Bạn có chắc muốn xóa?"
            onConfirm={() => onDelete(record._id)}
            okText="Có"
            cancelText="Không"
          >
            <Tooltip title="Xóa">
              <Button
                type="text"
                danger
                size="small"
                icon={<DeleteOutlined />}
              />
            </Tooltip>
          </Popconfirm>
        </Space>
      ),
    },
  ];

  return (
    <Table
      scroll={{ x: 1200 }}
      columns={columns}
      dataSource={
        data.length
          ? data.map((item, idx) => ({
              ...item,
              ...(filter && {
                key: (filter.page - 1) * filter.limit + idx + 1,
              }),
            }))
          : []
      }
      loading={loading}
      rowKey="_id"
      pagination={{
        current: filter.page,
        pageSize: filter.limit,
        total,
        showSizeChanger: true,
        onChange: (page, pageSize) =>
          onFilterChange({ ...filter, page, limit: pageSize }),
      }}
      size="middle"
      bordered
      rowClassName={() => "hover-row"}
    />
  );
}
